import { yupResolver } from '@hookform/resolvers/yup';
import CloseIcon from '@mui/icons-material/Close';
import ErrorIcon from '@mui/icons-material/Error';
import { MenuItem, Select } from '@mui/material';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { ptBR } from 'date-fns/locale';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import Modal from 'react-modal';
import { v4 as uuid } from 'uuid';
import { IHistoryViewModel, ISolicitationViewModel } from 'viewModels';
import * as yup from 'yup';
import { useTheme } from 'styled-components';
import { ReactComponent as Icon } from '../../../assets/icons/icon-edit-date.svg';
import { useAuth } from '../../../context';
import { useSolicitation } from '../../../context/solicitation';
import { SolicitationController } from '../../../controller/SolicitationController';
import { HistoryType } from '../../../types/enums';
import { Button } from '../../Buttons/Button';
import { ContentButtons, ContentModal, Header } from './styles';
import { add } from 'date-fns';

interface Props {
  isOpen: boolean;
  solicitation: ISolicitationViewModel;
  onRequestClose: () => void;
  zIndex?: number;
}
export function ModalAddDate({ isOpen, solicitation, onRequestClose, zIndex }: Props) {
  const theme = useTheme();
  const { solicitations, setSolicitations } = useSolicitation();
  const { user } = useAuth();
  const [isInvalidDate, setIsInvalidDate] = useState(false);
  const [minutesLimit, setMinutesLimit] = useState<number | null>(
    new Date(solicitation.dateLimit).getMinutes(),
  );
  const [dateLimit, setDateLimit] = useState<Date>(new Date(solicitation.dateLimit));
  const Hour = [
    0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23,
  ];
  const Minutes = [
    0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25,
    26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49,
    50, 51, 52, 53, 54, 55, 56, 57, 58, 59,
  ];
  const [hourLimit, setHourLimit] = useState<number>(new Date(solicitation.dateLimit).getHours());
  const defaultValues = {
    text: '',
    attachments: [],
    createdAt: new Date(),
    type: HistoryType.NOTE,
    createdBy: new Date(),
    demandId: '',
    solicitationId: '',
  };

  const MenuProps = {
    PaperProps: {
      style: {
        backgroundColor: theme.colors.background_white,
        color: theme.colors.secondary,
        maxHeight: 250,
        width: 50,
      },
    },
    MenuListProps: {
      sx: {
        'li.MuiButtonBase-root': {
          display: 'flex',
          flexDirection: 'column',
        },
      },
    },
  };

  const registerSchema = yup.object({
    text: yup.string().required('Campo obrigatório'),
    attachments: yup.array(),
    createdAt: yup.date(),
    type: yup.string(),
    createdBy: yup.date(),
    demandId: yup.string(),
    solicitationId: yup.string(),
  });

  const { reset } = useForm({
    resolver: yupResolver(registerSchema),
    reValidateMode: 'onChange',
    defaultValues,
  });

  const handleSelectDate = (selectedDate: Date | null) => {
    if (!selectedDate || isNaN(selectedDate.getTime())) {
      setIsInvalidDate(true);
      return;
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const chosenDate = new Date(selectedDate);
    chosenDate.setHours(0, 0, 0, 0);

    const isValid = chosenDate >= today;

    setIsInvalidDate(!isValid);

    if (isValid) {
      setDateLimit(selectedDate);
    }
  };

  const handleSendNewDate = () => {
    const date = new Date(
      dateLimit.getFullYear(),
      dateLimit.getMonth(),
      dateLimit.getDate(),
      hourLimit as number,
      minutesLimit as number,
    );

    if (solicitation.id && date) {
      SolicitationController.updateDateLimit(solicitation.id, date).then(() => {
        onRequestClose();
        reset();
        const history: IHistoryViewModel = {
          id: uuid(),
          createdBy: `${user?.firstName} ${user?.lastName}`,
          type: HistoryType.NEW_DATELIMIT,
          solicitationId: solicitation.id,
          createdAt: new Date(),
          visible: true,
          newSolicitationDateLimit: date,
          prevSolicitationDateLimit: solicitation.dateLimit,
        };
        const solicitationIdx = solicitations.findIndex((s) => s.id === solicitation.id);
        if (solicitationIdx !== -1) {
          const newSolicitations = solicitations;
          newSolicitations[solicitationIdx].dateLimit = date;
          newSolicitations[solicitationIdx].history?.push(history);
          newSolicitations[solicitationIdx].history?.sort(
            (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
          );
          setSolicitations([...newSolicitations]);
        }
      });
    }
  };

  const setZIndex =
    zIndex !== undefined
      ? {
          overlay: {
            zIndex: zIndex || 1,
          },
        }
      : {};

  return (
    <Modal
      style={setZIndex}
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      overlayClassName="react-modal-overlay"
      className="react-add-modal-content">
      <Header>
        <div className="subHeader">
          <Icon />
          <h1>Nova Data</h1>
        </div>
        <div className="close-div">
          <button type="button" onClick={onRequestClose}>
            <CloseIcon fontSize="small" />
          </button>
        </div>
      </Header>
      <ContentModal>
        <div className="containerDataSolicitation">
          <div className="limitDateContainer">
            <h2>Prazo</h2>

            <div className="contentDate">
              <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
                <DesktopDatePicker
                  value={dateLimit}
                  onChange={(e) => handleSelectDate(e)}
                  disablePast
                  minDate={add(new Date(), { days: 1 })}
                  onError={(reason) => {
                    if (reason !== null) {
                      setIsInvalidDate(true);
                    } else {
                      setIsInvalidDate(false);
                    }
                  }}
                />
              </LocalizationProvider>
              <div className="time">
                <h3>Hora</h3>
                <div className="dropdownTime">
                  <Select
                    onChange={(e) => {
                      setHourLimit(Number(e.target.value));
                    }}
                    value={hourLimit}
                    MenuProps={MenuProps}
                    displayEmpty
                    IconComponent={() => null}>
                    {Hour.map((hour) => (
                      <MenuItem value={hour} key={hour}>
                        {hour.toString().padStart(2, '0')}
                      </MenuItem>
                    ))}
                  </Select>
                </div>
                <h2>:</h2>
                <div className="dropdownTime">
                  <Select
                    onChange={(e) => {
                      setMinutesLimit(Number(e.target.value));
                    }}
                    value={minutesLimit}
                    MenuProps={MenuProps}
                    displayEmpty
                    IconComponent={() => null}>
                    {Minutes.map((minute) => (
                      <MenuItem value={minute} key={minute}>
                        {minute.toString().padStart(2, '0')}
                      </MenuItem>
                    ))}
                  </Select>
                </div>
              </div>
            </div>
            {isInvalidDate && (
              <span className="fieldError">
                <ErrorIcon fontSize="inherit" /> Data inválida
              </span>
            )}
          </div>
        </div>
      </ContentModal>
      <ContentButtons>
        <Button
          text="Salvar"
          style={{ fontSize: '1.20rem', display: 'flex', alignItems: 'center' }}
          dimensions={{
            width: '6rem',
            height: '2rem',
          }}
          disabled={isInvalidDate}
          positionLeftElement={5}
          border={{ color: 'secondary', width: 0 }}
          color="background_white"
          background="secondary"
          onClick={handleSendNewDate}
        />
      </ContentButtons>
      <ContentModal>
        <>
          <p className="title">Historico</p>
          <div className="content-map-date">
            <p className="header-table">Data</p>
            <p className="header-table">Hora</p>
            <p className="header-table">Nome</p>
          </div>
          {solicitation.history
            ?.filter((h) => Number(h.type) === Number(HistoryType.NEW_DATELIMIT))
            .map((item) => (
              <div className="content-map-date" key={item.id}>
                <p className="item-in-table">
                  {new Date(item.prevSolicitationDateLimit as Date).toLocaleString('pt-BR', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                  })}
                </p>
                <p className="item-in-table">
                  {new Date(item.prevSolicitationDateLimit as Date).toLocaleString('pt-BR', {
                    hour: '2-digit',
                    minute: '2-digit',
                  })}
                </p>
                <p className="item-in-table">{item.createdBy}</p>
              </div>
            ))}
        </>
      </ContentModal>
    </Modal>
  );
}
